import React, { createContext, useContext } from 'react';
import { ModelCache } from './index';

interface ModelCacheContextType {
  cache: ModelCache;
  addToCache: (id: string, url: string, scene: THREE.Group | null) => void;
}

export const ModelCacheContext = createContext<ModelCacheContextType>({
  cache: { models: {}, urls: {} },
  addToCache: () => {},
});

export const useModelCache = () => {
  const context = useContext(ModelCacheContext);
  if (!context) {
    throw new Error('useModelCache must be used within a ModelCacheProvider');
  }
  return context;
}; 